import { EventPriceDto, EventPriceToMembershipDto } from '../../models/dto';
import { DiscountTypeEnum } from '../../enums';

/**
 * Get the highest discount membership for a ticket.
 * @param basePrice
 * @param eventPriceToMemberships
 */
export const getHighestDiscountMembership = (
	basePrice: number,
	eventPriceToMemberships: EventPriceToMembershipDto[]
): EventPriceToMembershipDto | undefined => {
	if (!eventPriceToMemberships || eventPriceToMemberships?.length === 0) return;

	// calculate real discount values
	const calculatedDiscountsList = eventPriceToMemberships.map((membership) => {
		const discount =
			membership.type === DiscountTypeEnum.Percentage ? (basePrice * membership.amount) / 100 : membership.amount;

		return {
			...membership,
			discount,
		};
	});

	// sort the discounts in descending order
	const sortedDiscounts = calculatedDiscountsList.sort((a, b) => b.discount - a.discount);

	// return the highest discount
	return eventPriceToMemberships.find((m) => m.id === sortedDiscounts[0].id);
};

/**
 * Get the lowest price for a ticket.
 * @param ticket
 * @param eventPriceToMemberships
 */
export const getLowestTicketPrice = (
	ticket: EventPriceDto,
	eventPriceToMemberships?: EventPriceToMembershipDto[]
): number => {
	const basePrice = ticket.priceAmount;
	const memberships = eventPriceToMemberships || ticket.eventPriceToMemberships || [];

	// apply the membership discount with the highest discount
	const highestDiscountMembership = getHighestDiscountMembership(basePrice, memberships);

	if (!highestDiscountMembership) {
		return basePrice;
	}

	if (highestDiscountMembership.type === DiscountTypeEnum.Percentage) {
		return basePrice - (basePrice * highestDiscountMembership.amount) / 100;
	} else {
		return basePrice - highestDiscountMembership.amount;
	}
};
